export default __webpack_public_path__ + "static/media/inner.a2a6c8a8.svg";